import _ from 'lodash';
import icNotSelected from '../../../../../svg/massChange/icoItemNotSelected.svg';
import icSelectedPart from '../../../../../svg/massChange/icoItemPartSelected.svg';
import icSelected from '../../../../../svg/massChange/icoItemSelected.svg';
import icArrow from '../../../../../svg/massChange/icoMenuArrow.svg';
import getSvgIcon from '../../../helpers/getSvgIcon';
import overdue_icon from '../../../../../svg/deadline/deadline_time.svg';
import icon_timer from '../../../../../svg/footerToolbar/timer.svg';
import rights from '../../../../../components/rights';
import customHelper from '$$helpers/custom';
import dateHelper from '$$dateFormatsHelper';
import moment from 'moment';
import timeParser from '$$helpers/timeParser';
import constants from '$$helpers/constants';
import BaselineGrid from '../../../baselines/grid';
import MassSelect, { FULL_SELECTED, NO_SELECTED, PART_SELECTED } from '../../../controllers/massSelect';
import ColumnsConfig from '../columnsConfig';
import inlineEditors from '../../../controllers/inlineEditors';
import Costs from '../../../controllers/costs';
import Estimation from '../../../controllers/estimation';

const GRID_CELL_TEMPLATE_BY_COLUMN = {
  wbs: getWbsTemplate,
  masschange: getMassChangeTemplate,
  overdue: getOverdueTemplate,
  overload: getOverloadTemplate,
  comments: getCommentsTemplate,
  attachments: getAttachmentsTemplate,
  text: getTextTemplate,
  start_date: getStartDateTemplate,
  end_date: getEndDateTemplate,
  create_date: getCreateDateTemplate,
  duration: getDurationTemplate,
  estimation: getEstimationTemplate,
  creator: getCreatorTemplate,
  time_tracking: getTimeTrackingTemplate,
  progress: getProgressTemplate,
  resource_id: getResourcesTemplate,
  total_price: getTotalPriceTemplate,
  actual_cost: getActualCostTemplate,
  predecessors: getPredecessorsTemplate,
};

export const getTemplateForResource = resource => `<span class="resource_list_item_icon" style="background-image: url(${
  resource.photo || resource.resourcePhoto || (`${GT.cdn}/imgs/default/default-ava.svg`)})"></span>`;

function getDateFormatByProperty(property) {
  return ColumnsConfig.config.advancedOptions[property].check
    ? dateHelper.getDateFormatForGanttGrid()
    : dateHelper.getDateFormat();
}

function getResourcesTemplate(task, instance) {
  if (task.type === instance.config.types.project) {
    return '';
  }

  let resourceData = [];
  const isForBaseline = !!BaselineGrid.baselinesTasks[task.id];

  if (isForBaseline && task) {
    task.resources.forEach(resource => {
      const item = instance.ganttDataApi.getResourceById(resource.resource_id);

      item && resourceData.push(item);
    });
  } else {
    resourceData = instance.ganttDataApi.getResourcesByTaskIdAndGanttId(task.gantt_id, task.id);
  }

  const count = resourceData.length;

  if (!count) {
    return `${'<div class="resource-in-grid resource_list_in_grid unassigned">'
      + '<div class="resource_list_item_icon "></div>'
      + '<div class="resource_list_item">'}${__(constants.COMMON_EMPTY_RESOURCE)}</div>`
      + '</div>';
  }

  let html = '<div class="resource_list_in_grid resource-in-grid">';
  let more = 0;

  if (count === 1) {
    html += `${getTemplateForResource(resourceData[0])}<span class="resource_list_item">${resourceData[0].name}</span>`;
  } else {
    _.orderBy(resourceData, 'id').forEach((resource, i) => {
      if (count < 4) {
        html += getTemplateForResource(resource);
      } else if (i < 2) {
        html += getTemplateForResource(resource);
      } else if (!more) {
        more = count - 2;
        html += `<span class="resource_list_item_more">+${more}</span>`;
      }
    });
  }

  html += '</div>';

  return html;
}

function getWbsTemplate(task, instance) {
  const taskLevel = instance.calculateTaskLevel(task);

  if (!taskLevel || instance.ganttDataApi.isMassChangeEnabled() || instance.config.isArchived) {
    return '';
  }

  if (instance.config.multiview && taskLevel === 1) {
    return `<div class="gantt_grid_wbs gantt_grid_wbs_icon">${getSvgIcon('project', 'regular', 24)}</div>`;
  }

  return `<span class="gantt_grid_wbs">${instance.getWBSCode(task)}</span>`;
}

function getMassChangeTemplate(task, instance) {
  if (!instance.ganttDataApi.isMassChangeEnabled()) {
    return '<span class="mc-item-icon-container"></span>';
  }

  const selectedState = MassSelect.getEntrySelectionState(task.id);

  let checkBoxIcon = '';

  if (selectedState === NO_SELECTED) {
    checkBoxIcon = icNotSelected;
  } else if (selectedState === PART_SELECTED) {
    checkBoxIcon = icSelectedPart;
  } else if (selectedState === FULL_SELECTED) {
    checkBoxIcon = icSelected;
  }

  return `<div class="mc-item-icon-container">${checkBoxIcon}${instance.getTask(task.id).type === 'project' ? icArrow : ''}</div>`;
}

function getOverdueTemplate(task, instance) {
  const total_estimate = (task.type === 'project' && task.parent === 0);
  let dragIndicator = '';

  if (instance.ganttDataApi.isBase() && !total_estimate && rights.project.hasRight(task.gantt_id, 'drag_and_drop')) {
    dragIndicator = `<div class="drag-indicator">${getSvgIcon('dragdrop', 'regular', 24)}</div>`;
  }

  if (task.deadline && task.end_date > task.deadline) {
    return `${dragIndicator}<div class="overdue-indicator">${overdue_icon}</div>`;
  }

  return dragIndicator;
}

function getOverloadTemplate(task, instance) {
  const isTotalEstimateTask = instance.config.multiview ? task.$level === 1 : task.$level === 0;

  if (isTotalEstimateTask || instance.ganttDataApi.isMassChangeEnabled() || task.type === instance.config.types.button || task.type === instance.config.types.project) {
    return '';
  }

  if (instance.ganttDataApi.getOverloadedResources({ taskId: task.id })) {
    return `<div class="overload-indicator tooltip-gantt" data-align="${((instance.ganttDataApi.getLeftSidebarWidth() === 40) || instance.ganttDataApi.isExport()) ? 'left' : 'center'}" data-key="overload_tooltip_grid">${getSvgIcon('resource', 'regular', 24)}</div>`;
  }

  return '';
}

function getCommentsTemplate(task, instance) {
  const isTotalEstimateTask = instance.config.multiview ? task.$level === 1 : task.$level === 0;

  if (isTotalEstimateTask || instance.ganttDataApi.isMassChangeEnabled()) {
    return '';
  }

  return `<div class='notification_cell_comments ${task.hasComments ? 'has' : ''} ${instance.ganttDataApi.isBase() && instance.ganttDataApi.getTaskCommentsMetaData(task.id)?.unreadComments.size ? 'new' : ''}'>
            ${!instance.ganttDataApi.isHistory() ? getSvgIcon('comments', 'regular', 24) : ''}
          </div>`;
}

function getAttachmentsTemplate(task, instance) {
  const isTotalEstimateTask = instance.config.multiview ? task.$level === 1 : task.$level === 0;

  if (isTotalEstimateTask || instance.ganttDataApi.isMassChangeEnabled()) {
    return '';
  }

  return `<div class='notification_cell_attachments ${task.hasAttachments ? 'has' : ''}' >
            ${!instance.ganttDataApi.isHistory() ? getSvgIcon('attach', 'regular', 24) : ''}
         </div>`;
}

function getTextTemplate(task, instance) {
  const isMultiview = instance.config.multiview;

  if (task.type === instance.config.types.button) {
    const addTaskAndMilestoneDisableLevel = 1;

    const addTaskMilestone = `<span class="button js_add_milestone">${__('gantt_add_milestone')}</span>`;
    const addTaskButton = `<span class="button js_add_task">${__('gantt_add_task_placeholder')}</span>`;
    const addTaskIconButton = `<span class='button button-icon js_add_task'>${getSvgIcon('plus-2', 'regular', 20)}</span>`;
    const separatorLine = '<span class=\'separator-line\'></span>';

    const lineStyles = inlineEditors.lineHeight ? `style=\'height: ${+inlineEditors.lineHeight}px;\'` : '';
    const baselineLine = instance.config.baseline === 1 ? `<span class=\'line baseline_active\' ${lineStyles}></span>` : `<span class=\'line\' ${lineStyles}></span>`;

    const addTaskAndMilestone = `
                  <div class="project-control">
                    ${/* input + */baselineLine}
                    <div class="buttons">
                      ${addTaskIconButton}
                      ${addTaskButton}${separatorLine}${addTaskMilestone}
                    </div>
                  </div>`;

    if (!(isMultiview && instance.calculateTaskLevel(task.id) === addTaskAndMilestoneDisableLevel)) {
      return addTaskAndMilestone;
    }

    return '';
  }

  if (isMultiview && task.$level === 1) {
    const project = instance.ganttDataApi.getProjectItem(task.gantt_id);

    if (project) {
      return project.name;
    }
  }

  return customHelper.formatTaskName(task.text).trim();
}

function getStartDateTemplate(task, instance) {
  return instance.date.date_to_str(getDateFormatByProperty('start_date'))(task.start_date);
}

function getEndDateTemplate(task, instance) {
  return instance.date.date_to_str(getDateFormatByProperty('end_date'))(task.end_date);
}

function getCreateDateTemplate(task, instance) {
  if (instance.config.multiview && task.$level === 0) {
    return '';
  }

  const date = task.created_at ? new Date(task.created_at) : task.start_date;

  return instance.date.date_to_str(getDateFormatByProperty('create_date'))(date);
}

function getCreatorTemplate(task, instance) {
  if (task.type === instance.config.types.project) {
    return '';
  }

  const resourceData = instance.ganttDataApi.getResourceById(task.owner_id);

  if (resourceData) {
    return resourceData.name;
  }

  return __('creator_removed_from_team');
}

function getEstimationTemplate(task, instance, isBaseline, baselineState) {
  if (task.type === instance.config.types.button || task.type === instance.config.types.milestone) {
    return '';
  }

  return Estimation.getEstimationValueForTask(task, isBaseline, baselineState);
}

function getDurationTemplate(task, instance) {
  if (task.type === instance.config.types.milestone) {
    return '';
  }

  if (instance.config.multiview && task.$level === 0) {
    return '';
  }

  const value = instance.calculateDuration(
    moment(task.start_date).toDate(),
    moment(task.end_date).toDate(),
    task,
  );

  let durationData = instance.config.durationData;
  const projectCalendar = instance.getCalendar(task.gantt_id);

  if (projectCalendar) {
    durationData = {
      showDay: Object.keys(projectCalendar.getConfig().dates)
        .filter(key => +projectCalendar.getConfig().dates[key]),
      showTime: _.clone(projectCalendar.getConfig().hours),
    };
  }

  return timeParser.output(value, {
    durationData,
    durationStep: instance.config.duration_view,
    prop: 'duration',
  });
}

function getTimeTrackingTemplate(task, instance) {
  if (task.type === instance.config.types.button) {
    return '';
  }

  const taskLogs = instance.ganttDataApi.getTimeLogsByParams(task.gantt_id, task.id);
  let value = taskLogs?.sum || 0;
  let sumForParent = 0;

  if (task.type === instance.config.types.project) {
    instance.eachTask(childTask => {
      if (childTask.type !== instance.config.types.button) {
        const logsData = instance.ganttDataApi.getTimeLogsByParams(childTask.gantt_id, childTask.id);

        sumForParent += logsData ? logsData.sum : 0;
      }
    }, task.id);
  }

  const userActivity = _.find(user.activity, o => o.name === 'timeTracker');
  let trackerData = null;

  if (userActivity) {
    trackerData = JSON.parse(userActivity.settings);
  }

  if (trackerData && trackerData.task_id === task.id) {
    return icon_timer;
  }

  if (task.$level === 0) {
    value = sumForParent;
  }

  const text = timeParser.output(value, {});

  let template = `<div class="time_tracking_in_grid">${text}</div>`;

  if (task.type === instance.config.types.project && (sumForParent + value) && task.$level !== 0) {
    const textSum = timeParser.output(sumForParent + value, {});

    template = `<div class="time_tracking_in_grid sum"><div class="sum_label">${`${__('sum_time_label')} ${textSum}`}</div><div class="text">${text}</div></div>`;
  }

  return template;
}

function getProgressTemplate(task, instance) {
  if (instance.config.multiview && instance.calculateTaskLevel(task.id) === 0) {
    return '';
  }

  return `${parseFloat(task.progress * 100).toFixed(0)}%`;
}

function getTotalPriceTemplate(task, instance, isBaseline, baselineState) {
  if (task.type === instance.config.types.button) {
    return '';
  }

  return Costs.getPriceValueForTask(task, isBaseline, baselineState);
}

function getActualCostTemplate(task, instance) {
  if (task.type === instance.config.types.button) {
    return '';
  }

  return Costs.getActualCostValueForTask(task);
}
function getPredecessorsTemplate(task, instance) {
  const linksFormatter = instance.ext.formatters.linkFormatter();

  // if (task.hasOwnProperty('linkValues')) {
  //   return task.linkValues;
  // }

  const links = task.$target || [];
  const labels = [];

  for (let i = 0; i < links.length; i++) {
    const link = {
      ...instance.getLink(links[i]),
      type: '0',
      lag: 0,
    };

    if (instance.isTaskExists(link.source)) {
      labels.push(linksFormatter.format(link));
    }
  }

  return labels.join(', ');
}
export function getTemplate(columnName, instance, task, isBaseline = false, baselineState) {
  if (!GRID_CELL_TEMPLATE_BY_COLUMN[columnName]) {
    throw `Template function does not exist for column - ${columnName}`;
  }

  return GRID_CELL_TEMPLATE_BY_COLUMN[columnName](task, instance, isBaseline, baselineState);
}
